import styled from 'styled-components';
import { theme } from 'styled-tools';

import { Label } from 'components';
export const ContentsContainer = styled.div`
`;

export const ContentsWrapper = styled.div`
`;

export const TitleWrapper = styled.div`
    padding: 12px 20px;
    display: flex;
    justify-content: space-between;
`;

export const ItemContainer = styled.div``;

export const TitleLabel = styled(Label)`
    ${theme('fontStyle.title_bold')}
`;

export const DeleteBtnWrapper = styled.div`
    height: 24px;
    position: relative;

    button {
        position: relative;
        display: flex;
        align-items: center;
    }

    svg {
        margin-right: 4px;
    }
`;